import BaseConfiguratorService from '@configuratorware/configurator-frontendgui/App/Services/ConfiguratorService';
import { hasComponentGroups } from '../App/Reducers/Configurator/Selecctors';

export default class ConfiguratorService extends BaseConfiguratorService {
  loadOptions(itemIdentifier, optionClassificationIdentifier, configuration) {
    if (hasComponentGroups(configuration)) {
      return;
    }
    return super.loadOptions(itemIdentifier, optionClassificationIdentifier, configuration);
  }

  getPreviewImagesForVariants(options = {}) {
    return super.getPreviewImagesForVariants({ ...options, size: { width: 500, height: 300 } });
  }
}
